/**
 * @file
 * NCBE accordion
 */

(($, Drupal) => {

  Drupal.behaviors.ncbe_accordion = {
    attach: function (context) {

      // jQuery UI accordion for Accordion paragraph type
      once('ncbe-accordion', '.ncbe-accordion', context).forEach((el) => {
        $(el).accordion({
          header: '> .field__item > .paragraph > h3',
          collapsible: true,
          active: false,
          animated: 'slide',
          autoHeight: true,
          navigation: true,
          heightStyle: 'content'
        });
      });
    }
  };

})(jQuery, Drupal, once);
